import Text from '@/shared-components/text/components/Text';
import ToggleSwitch from '@/shared-components/toggles/ToggleSwitch';

import './styles/WriteReview.css';

export default function WriteReview({ typeOfArtwork, formState, setFormState }) {
  return (
    <>
      <div className="write-review__container">
        <Text 
          className="add-review__write-review-text" 
        >
          {
            formState.valoration === "positive" ?
              "Glad to hear it arrived safely and you're happy with it! "
              : formState.valoration === "neutral" ?
                "We are sorry your experience was not perfect. "
                :
                "We apologize if it didn't meet your expectations. "
          }
        </Text>

        <Text 
          className="add-review__write-review-text" 
        >
          {
            typeOfArtwork === "original" ?
              "Your feedback contributes to the gallery's growth and improvement."
              :
              "Your feedback contributes to Suarte's growth and improvement."
          }
        </Text>

        <textarea 
          placeholder="Write a review"
          className="write-review__textarea font-size-medium"
          value={formState.comment}
          onChange={e=>setFormState({ ...formState, comment: e.target.value })}
          spellCheck={false}
        />

        <div className="write-review__anonymous">
          <div className="write-review__anonymous-switch">
            <ToggleSwitch
              checked={formState.is_anonymous}
              onChange={value=>setFormState({ ...formState, is_anonymous: value })}
            />
          </div>
          <Text className="add-review__anonymous-text font-size-small">
                        Make it anonymous
          </Text>
        </div>
      </div>
    </>
  );
}
